import { Button, Flex, Popover, Tooltip } from '@taxbit-private/cosmic'
import { useCallback } from 'react'

import { AirflowDagContext } from 'api/types/gcDagApiTypes'
import PermissionTooltip from 'components/permission-tooltip/PermissionTooltip'
import Permission from 'constants/Permissions'
import { useTriggerGcDag } from 'hooks/data/gc-dags/gcDagHooks'
import useAppStore from 'store/useAppStore'

import { RefreshButton } from './DataStatusButtons'
import RunStatus from './GlobalRunStatus'

const context: AirflowDagContext = { catch_up: false }

const GlobalSyncPopover = () => {
  const { mutate: triggerGcDag } = useTriggerGcDag()
  const addCosmicToast = useAppStore((store) => store.addCosmicToast)

  const handleSave = useCallback(() => {
    const onSuccess = () => {
      addCosmicToast({
        variant: 'primary',
        message: 'Reprocessing data. This workspace will be updated with the changes made.',
      })
    }

    const onError = () => {
      addCosmicToast({
        variant: 'danger',
        message:
          'Failed to reprocess data. Try again and please contact us at help@taxbit.com if this issue persists.',
      })
    }

    triggerGcDag({ context }, { onSuccess, onError })
  }, [triggerGcDag, addCosmicToast])

  return (
    <Popover
      contents={
        <Tooltip
          target={
            <Flex padding="m" direction="column" gap="s">
              <PermissionTooltip permissionName={Permission.TransactionDataEdit} placement="left">
                {({ userHasPermission }) => (
                  <Button
                    iconName="refresh"
                    trackingId="sync-now-button-id"
                    label="Reprocess data"
                    onClick={handleSave}
                    isDisabled={!userHasPermission}
                  />
                )}
              </PermissionTooltip>
              <RunStatus />
            </Flex>
          }
          content="Workspace data is reprocessed automatically every 24 hours."
        />
      }
      targetButtonProps={{
        as: RefreshButton,
        iconName: 'refresh',
        trackingId: 'global-edits-icon-id',
        variant: 'white',
      }}
    />
  )
}

export default GlobalSyncPopover
